import { render, staticRenderFns } from "./ClaimAnalysis.vue?vue&type=template&id=4851fd18&scoped=true&"
import script from "./ClaimAnalysis.vue?vue&type=script&lang=js&"
export * from "./ClaimAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ClaimAnalysis.vue?vue&type=style&index=0&id=4851fd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851fd18",
  null
  
)

export default component.exports